import { apiClient } from "./client";
import type { LoyaltyRow } from "../../types";
import type { LoyaltyCardDetailResponse, LoyaltyDatasetResponse } from "./types";

export async function fetchLoyaltyDataset() {
    const response = await apiClient.get<LoyaltyDatasetResponse>("/loyalty");

    return response.data;
}

export async function fetchLoyaltyCardDetail(partnerId: number) {
    const response = await apiClient.get<LoyaltyCardDetailResponse>(`/loyalty/cards/${partnerId}`);

    return response.data;
}

/** Търсене в Base + POS (retaileur) — пълен набор карти. */
export async function fetchLoyaltyCardByNumber(cardNumber: string): Promise<LoyaltyRow | null> {
    try {
        const response = await apiClient.get<{ card: LoyaltyRow }>("/loyalty/cards/by-number", {
            params: { card: cardNumber },
        });

        return response.data.card;
    } catch {
        return null;
    }
}
